import { useCallback, useEffect, useRef } from "react";
import { FINISH_DELAY_MS } from "../engine/lessonTypes";
import { showLessonCompleteToast } from "../../app/stores/toastStore";

/**
 * Handles the standard delay between a correct answer/run and advancing to the
 * next lesson, including the success toast and unmount cleanup.
 */
export function useLessonFinish(onFinished: () => void, notify = false) {
  const finishTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (finishTimerRef.current !== null) {
        clearTimeout(finishTimerRef.current);
        finishTimerRef.current = null;
      }
    };
  }, []);

  const scheduleFinish = useCallback((): void => {
    if (finishTimerRef.current !== null) return;
    if (notify) showLessonCompleteToast();
    finishTimerRef.current = setTimeout(() => {
      finishTimerRef.current = null;
      onFinished();
    }, FINISH_DELAY_MS);
  }, [onFinished, notify]);

  return { scheduleFinish };
}
